<template src="./Index.html"></template>

<script>
export default {
  created() {
    this.$store.dispatch("lookups/getAdministrations");
    this.$store.dispatch("lookups/getJobGroups");
    this.$store.dispatch("lookups/getJobGrades");
    this.getjobGradesByAdminId();
    this.status = this.employee.status;
  },
  mounted(){
    this.status = this.employee.status;
    console.log('mounted')
  },
  model: {
    prop: "employee",
  },
  props: ["employee", "hasLeaves"],
  computed: {
    jobs() {
      return this.$store.state.lookups.jobs;
    },
    jobGroups() {
      return this.$store.state.lookups.jobGroups;
    },
    administrations() {
      return this.$store.state.lookups.administrations;
    },
    departments() {
      return this.$store.state.lookups.departments;
    },
    jobTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.ContractTypes
      );
    },
    delegatedTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.DelegatedTypes
      );
    },
    jobGrades() {
      return this.$store.state.lookups.filteredJobGrades;
    },
    correlators() {
      return [
        { value: 0, label: "0" },
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
        { value: 7, label: "7" },
        { value: 8, label: "8" },
        { value: 9, label: "9" },
        { value: 10, label: "10" },
      ];
    },
    units() {
      return this.$store.state.lookups.units;
    },
    disabled() {
      return (this.employee.type == 2 && this.employee.status != 10);
    },
  },
  data() {
    return {
     // disabled: (this.employee.type == 2 && this.status != 10),
      status:null,
      jobGroupId: null,
    };
  },
  methods: {

    getjobGradesByAdminId() {
      this.$store.dispatch(
        "lookups/getjobGradesByAdminId",
        this.employee.employmentInformation.administrationId
      );
    },
    getJobs() {
      this.$store.dispatch(
        "lookups/getJobsByGroup",
        this.employee.employmentInformation.jobGroupId
      );
    },
    uploadEmploymentPhoto() {
      const reader = new FileReader();
      if (event.target.files.length) {
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          this.employee.employmentInformation.employmentPhoto =
            event.target.result;
        };
      }
    },
    uploadStartingPhoto() {
      const reader = new FileReader();
      if (event.target.files.length) {
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          this.employee.employmentInformation.startingPhoto =
            event.target.result;
        };
      }
    },
    changeAdministration() {
      this.employee.employmentInformation.departmentId = null;
      this.employee.employmentInformation.unitId = null;
      this.getjobGradesByAdminId();
      //let administration = this.administrations.find((x) => {
      //  return x.value == this.employee.employmentInformation.administrationId;
      //});

      //console.log(administration.type)
      /*      if (administration.type != 1002) {*/
      this.$store.dispatch(
        "lookups/getDepartments",
        this.employee.employmentInformation.administrationId
      );
      /*  } else {*/
      this.$store.dispatch("lookups/getUnitsById", {
        typeId: 1,
        id: this.employee.employmentInformation.administrationId,
      });
      //}
    },
    getUnits() {
      this.employee.employmentInformation.unitId = null;
      this.$store.dispatch("lookups/getUnitsById", {
        typeId: 2,
        id: this.employee.employmentInformation.departmentId,
      });
    },
    nextStep() {
      this.$emit("nextStep");
    },
    prevStep() {
      console.log(this.employee);

      this.$emit("prevStep");
    },
    allowedDates(val) {
      const today = new Date();
      const date = new Date(val);
      return date < today;
    },
  },
};
</script>
